import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {useLectureAttend} from '@hooks';
import {LectureInstructorModal} from './LectureInstructorModal';
import LectureTabNav from './LectureTabNav';
const LectureAttendance = () => {
  const { lectureId } = useParams();
  const navigate = useNavigate();
  const [formModalOpen, setFormModalOpen] = useState(false);

  const {
    dates, eduDt, setEduDt,
    classNos,
    attendData, lectureData,
    selectedRows,  allRowsChecked,
    toggleRow, selectAllRows,
    bulkAttend, bulkAbsent, toggleCell, handleExcelDownload
  } = useLectureAttend(lectureId);

  if (!attendData) return null;

  const handleInstructorList = () => {
    setFormModalOpen(true);
  };


  return (
    <div className="contents-wrap">
        <LectureTabNav lectureId={lectureId} active="attend" />
        
        <div className="search-wrap" style={{display:"flex", alignItems:"center"}}>
        {/* <span className="icon-diamond"></span> */}
        <label style={{marginRight:"10px", fontWeight:"bold", fontSize:"1.1rem"}}>강의일</label>
        {dates.map((d,i)=>(
          <button key={d}
                  className={eduDt===d ? "btn-normal" : "btn-add"}
                  style={{ cursor:"pointer", marginLeft:"5px", fontWeight:"bold"}}
                  onClick={()=>setEduDt(d)}>
            {d}
          </button>
        ))}
        </div>  
      <div className="attend-wrap">  
        <div className="section-tit-wrap" style={{display:"flex", justifyContent:"space-between"}}>
          <h3 className="border-left-primary">
              &nbsp;수강생&nbsp;
              <span className="total-txt red">{attendData.length}</span> 명
          </h3>
          <div className="btn-right-box">
              <ul>
              <li><button  className="btn-excel" onClick={handleExcelDownload}>엑셀</button></li>

              <li><button  className="btn-add" onClick={handleInstructorList}>강사목록</button></li>
              <li><button  className="btn-save" onClick={bulkAttend}>일괄출석</button></li>
              <li><button  className="btn-save" onClick={bulkAbsent}>일괄결석</button></li>
              </ul>
          </div>
        </div>

        {/* 출석 테이블 */}
        <div className="table-container">
        <div className="table-box">
          <table className="table-list" style={{tableLayout:"fixed"}}>
          <colgroup>
            <col style={{ width: "3%" }} />  {/* 체크박스 */}
            <col style={{ width: "10%" }} /> {/* 성명 */}
            <col style={{ width: "10%" }} /> {/* 생년월일 */}
            <col style={{ width: "12%" }} /> {/* 소속 */}
            {classNos.map(() => (
              <col key={crypto.randomUUID()} style={{ width: `${55 / classNos.length}%` }} />
            ))}
            <col style={{ width: "80px" }} /> {/* 종합: 고정 80px */}
          </colgroup>
          <thead>
              <tr>
                <th>
                  <input type="checkbox"
                        checked={allRowsChecked}
                        onChange={(e)=>selectAllRows(e.target.checked)} />
                </th>
                <th>성명</th>
                <th>생년월일</th>
                <th>소속</th>
                {classNos.map(no=>(
                  <th key={no}>{no}교시</th>
                ))}
                <th>종합</th>
              </tr>
            </thead>
            <tbody>
              {attendData.map((s,i)=>{
                const allY = classNos.every(no=>s.attend[no]==="Y");
                return (
                  <tr key={s.memberId}>
                    <td>
                      <input type="checkbox"
                            checked={selectedRows.includes(s.memberId)}
                            onChange={()=>toggleRow(s.memberId)} />
                    </td>
                    <td >{s.memberNm}</td>
                    <td >{s.birthDt}</td>
                    <td >{s.companyNm}</td>
                    {classNos.map(no=>(
                      <td key={no}>
                        <input type="checkbox"
                              checked={s.attend[no]==="Y"}
                              onChange={(e)=>toggleCell(
                                s.memberId, no, e.target.checked?"Y":"N")} />
                      </td>
                    ))}
                    <td >{allY ? "출석완료" : "대기"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        </div>
      </div>
      <LectureInstructorModal
        isOpen={formModalOpen}
        onClose={() => setFormModalOpen(false)}
        insList={lectureData.ins}
      />
    </div>
    
  );
}

export {LectureAttendance};
